import "../../../assets/css/cms/Cms.css";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
const Stepper = (props) => {
  const [activeState, setActiveState] = useState(
    props.activeState ? props.activeState : 0
  );
  const { id } = useParams();
  const navigate = useNavigate();

  const onClickStateChange = (key, obj) => {
    if (id) {
      const basePath = window.location.pathname?.split('/')?.slice(0,-2)?.join('/')
      setActiveState(key);
      if (obj.route) {
          if (id) {
              navigate(`${basePath}/${id}/${obj.route}`)
          } else {
              navigate(`${basePath}/${obj.route}`);
          }
      } else {
          navigate(basePath);
      }
    } else {
      alert("Please fill the overview form first");
    }
  };

  // useEffect(() => {
  //   if (!id) {
  //     const basePath = window.location.pathname?.split('/')?.slice(0,-1)?.join('/')
  //     let obj = props.data?.[0]
  //     setActiveState(0);
  //     if (obj.route) {
  //         if (id) {
  //             navigate(`${basePath}/${id}/${obj.route}`)
  //         } else {
  //             navigate(`${basePath}/${obj.route}`);
  //         }
  //     } else {
  //         navigate(basePath);
  //     }
  //   }
  // }, []);

  useEffect(() => {
    if (props.activeStep) {
      setActiveState(props.activeStep);
    }
  }, [props.activeStep]);

  return (
    <div>
      <div className={"stepper_horizontal"}>
        {props.data.map((arr, key) => {
          return (
            <div className={"TabCard"}>
              <div className={"tab_box"}>
                <span
                  className={`${"tab_step"} ${
                    key == activeState ? `${"tab_step_active"}` : ""
                  } ${key < activeState ? `${"completed"}` : ""}`}
                  onClick={() => onClickStateChange(key, arr)}
                >
                  {key + 1}
                </span>
                <p className={"tab_para"}>{arr.title}</p>
                {key != 0 && (
                  <span
                    className={`${"tab_line_left"} ${
                      key <= activeState ? `${"tab_line_active"}` : ""
                    }`}
                  ></span>
                )}
                {key != props.data.length - 1 && (
                  <span
                    className={`${"tab_line_right"}  ${
                      key < activeState ? `${"tab_line_active"}` : ""
                    }`}
                  ></span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper;
